<script setup lang="ts">
import {onMounted, ref,watch} from "vue";
import {useStore} from "@/store";
import {storeToRefs} from "pinia";
const store = useStore()
const {homeConfig,industry} = storeToRefs(store)
const {getBaseInfo} = store
let lastScrollTop = 0;
let headerIn = ref(0);


const handelScroll = () => {
    let topnum = 100;
    let botnum = 140;
    if (window.innerWidth < 1200) {
      topnum = 50;
      botnum = 60;
    }
    let currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;
    if (currentScroll < lastScrollTop) {
      headerIn.value = 1;
      if (lastScrollTop < topnum) {
        headerIn.value = 3;
      }
    } else {
      if (lastScrollTop > botnum) {
        headerIn.value = 2;
      }
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
}
onMounted(() => {
    // getBaseInfo()
   

    window.addEventListener(
      "scroll",
      handelScroll,
      false
    );
});


import { useRouter} from 'vue-router'
const router = useRouter()

let showSlide = ref(false);

// 移动端二级导航展开状态
const mobileExpandIndex = ref(-1);
const toggleMobileNav = (index: number) => {
  mobileExpandIndex.value = mobileExpandIndex.value === index ? -1 : index;
};

// 行业方案下拉菜单：三级导航出场延迟（从左到右、从上到下依次出现）
const itemDelay = (col: number, k: number) => {
  let base = (industry.value.length || 0) * 60;
  for (let x = 0; x < col; x++) {
    base += (industry.value[x]?.list?.length || 0) * 30;
  }
  return base + k * 30;
};

// 下拉菜单 JS 控制：鼠标斜向移动时不会误消失
const activeNavIndex = ref(-1); // 当前激活的导航索引，-1 表示无
let hideTimer: ReturnType<typeof setTimeout> | null = null;
let lastNavEnterTime = 0;

const onNavEnter = (index: number) => {
  if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
  activeNavIndex.value = index;
  lastNavEnterTime = Date.now();
};
const onNavLeave = () => {
  hideTimer = setTimeout(() => { activeNavIndex.value = -1; }, 500);
};
const onDropdownEnter = () => {
  if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
};
const onDropdownLeave = () => {
  activeNavIndex.value = -1;
};

// 点击下拉菜单中的链接后关闭下拉
const closeDropdown = () => {
  activeNavIndex.value = -1;
};

// 触摸设备：点击切换下拉（mouseenter 在触摸设备不可靠）
// 忽略紧跟 mouseenter 的 click（触摸设备上两者会连续触发）
const toggleDropdown = (index: number) => {
  if (Date.now() - lastNavEnterTime < 300) return;
  activeNavIndex.value = activeNavIndex.value === index ? -1 : index;
};

// 监听当前路由
watch(
  () => router.currentRoute.value,
  (newValue: any) => {
    // console.log('newValue',newValue)
    setTimeout(() => {
      lastScrollTop=0
      headerIn.value = 0;
      handelScroll();
    }, 300);
    activeNavIndex.value = -1;
  },
  { immediate: true }
)
</script>
<template>
  <header>
    <div
      class="float"
      :class="{ in: headerIn == 1, out: headerIn == 2, black: headerIn == 3 }"
    >
      <div class="wp">
       
        <div class="header">
          <div class="l">
            <router-link to="/" class="logo">
              <img :src="homeConfig.logo" alt="" />
            </router-link>
          </div>
          <div class="r center">
            <div class="h-nav">
              <div
                class="center"
                :class="{ active: activeNavIndex === index }"
                v-for="(item,index) in homeConfig.navList"
                :key="index"
                @mouseenter="onNavEnter(index)"
                @mouseleave="onNavLeave()"
              >
                <router-link v-if="!['行业场景','技术路径','关于元墟'].includes(item.title)" :to="item.link">{{item.title}}</router-link>
                <div style="cursor: pointer;" v-else @click="toggleDropdown(index)">{{item.title}}</div>
                <!-- 行业方案：二级/三级导航下拉 -->
                <div
                  class="industry-dropdown"
                  v-if="item.link === '    ' && industry.length"
                  @mouseenter="onDropdownEnter()"
                  @mouseleave="onDropdownLeave()"
                >
                  <div class="industry-inner">
                    <div class="industry-titles">
                      <div
                        class="title-cell"
                        v-for="(ind, i) in industry"
                        :key="ind.id"
                        :style="{ '--delay': i * 60 + 'ms' }"
                      >
                        <router-link :to="`/industrySolutions?id=${ind.id}`" @click="closeDropdown">{{ ind.title }}</router-link>
                      </div>
                    </div>
                    <div class="industry-cols">
                      <div class="col" v-for="(ind, j) in industry" :key="ind.id">
                        <router-link
                          class="col-item"
                          v-for="(sub, k) in ind.list"
                          :key="sub.id"
                          :to="`/industrySolutions?id=${ind.id}&cid=${sub.id}&anchor=${sub.id}`"
                          :style="{ '--delay': itemDelay(j, k) + 'ms' }"
                          @click="closeDropdown"
                        >
                          <span class="name">{{ sub.title }}</span>
                          <span class="tag">｜{{ sub.shouzhong }}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 技术路径：二级导航下拉 -->
                <div
                  class="tech-dropdown"
                  v-if="item.title === '技术路径'"
                  @mouseenter="onDropdownEnter()"
                  @mouseleave="onDropdownLeave()"
                >
                  <div class="tech-inner">
                    <router-link v-for="value in homeConfig.nav_jishulujing" :key="value.title" :to="value.link" class="tech-card" @click="closeDropdown" :style="{ '--delay': 0 * 60 + 'ms' }">
                      <div class="tech-img-wrap">
                        <img :src="value.img" alt="" class="tech-img" />
                      </div>
                      <div class="tech-line"></div>
                      <span class="tech-label">{{value.title}}</span>
                    </router-link>
                  </div>
                </div>
                <!-- 元虚：二级导航下拉 -->
                <div
                  class="tech-dropdown"
                  v-if="item.title === '关于元墟'"
                  @mouseenter="onDropdownEnter()"
                  @mouseleave="onDropdownLeave()"
                >
                  <div class="tech-inner">
                    <router-link v-for="value in homeConfig.nav_about" :to="value.link" :key="value.title" class="tech-card" @click="closeDropdown" :style="{ '--delay': 0 * 60 + 'ms' }">
                      <div class="tech-img-wrap">
                        <img :src="value.img" alt="" class="tech-img" />
                      </div>
                      <div class="tech-line"></div>
                      <span class="tech-label">{{value.title}}</span>
                    </router-link>
                    
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="mode-btn">
              <img src="@svg/header-rightsvg.svg" alt="" />
            </div> -->
          </div>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </header>
  <!-- 移动端 -->
  <div class="header_m">
    <div
      class="float"
      :class="{ in: headerIn == 1, out: headerIn == 2, black: headerIn == 3 }"
    >
      <div class="wp">
        <div class="hd-box">
          <div class="logo">
            <router-link to="/">
              <img src="@svg/header-logo.svg" alt="" />
            </router-link>
          </div>
          <div class="menuBtn" @click="showSlide = true">
            <img src="@svg/menu1.svg" alt="" />
          </div>
        </div>
        <div class="line"></div>
      </div>
    </div>
    <div class="pop-nav" v-if="showSlide">
      <div class="wp">
        <div class="hd-box">
          <div class="logo">
            <router-link to="/">
              <img src="@svg/MF_Logo.svg" alt="" />
            </router-link>
          </div>
          <div class="menuBtn" @click="showSlide = false">
            <img src="@svg/menu2.svg" alt="" />
          </div>
        </div>
        <ul class="hdnav">
          <li class="nav-home">
            <router-link class="v1" to="/" @click="showSlide = false">首页</router-link>
          </li>
          <li v-for="(item,index) in homeConfig.navList" :key="index" :class="{ 'has-sub': ['行业场景','技术路径','关于元墟'].includes(item.title), expanded: mobileExpandIndex === index }">
            <div class="nav-item-row">
              <router-link v-if="!['行业场景','技术路径','关于元墟'].includes(item.title)" class="v1" :to="item.link" @click="showSlide = false">{{item.title}}</router-link>
              <span v-else class="v1 nav-toggle" @click="toggleMobileNav(index)">{{item.title}}</span>
              <span v-if="['行业场景','技术路径','关于元墟'].includes(item.title)" class="expand-icon" @click="toggleMobileNav(index)">{{ mobileExpandIndex === index ? '-' : '+' }}</span>
            </div>
            <!-- 行业场景二级导航 -->
            <div class="sub-nav" v-if="item.title === '行业场景' && mobileExpandIndex === index">
              <router-link v-for="ind in industry" :key="ind.id" class="sub-item" :to="`/industrySolutions?id=${ind.id}`" @click="showSlide = false">{{ ind.title }}</router-link>
            </div>
            <!-- 技术路径二级导航 -->
            <div class="sub-nav" v-if="item.title === '技术路径' && mobileExpandIndex === index">
              <router-link v-for="value in homeConfig.nav_jishulujing" :key="value.title" class="sub-item" :to="value.link" @click="showSlide = false">{{ value.title }}</router-link>
            </div>
            <!-- 关于元墟二级导航 -->
            <div class="sub-nav" v-if="item.title === '关于元墟' && mobileExpandIndex === index">
              <router-link v-for="value in homeConfig.nav_about" :key="value.title" class="sub-item" :to="value.link" @click="showSlide = false">{{ value.title }}</router-link>
            </div>
          </li>
        </ul>
        <div class="pop-bot">
          <div class="ll">
            <div class="lang act">Chinese</div>
            <div class="lang">English</div>
          </div>
          <div class="rr"><img src="@svg/header-rightsvg.svg" alt="" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
header {
  max-width: 1760px;
  width: 100%;
  height: 140rem;
}
.header_m {
  display: none;
}
.header {
  width: 100%;
  height: 140rem;
  color: #f5f5f7;
  background-color: #000;
}
.float {
  position: fixed;
  width: 100%;
  z-index: 99;
  background-color: #000;
  // background: #000000;
  transition: .4s;
  top: 0;
  left: 0;
  &.in {
    transform: translateY(0rem) !important;
    transition: transform 0.4s;
    background: #000000;
  }
  &.out {
    transform: translateY(-140rem);
    transition: transform 0.4s;
    background: #000000;
  }
  /* &.black {
    background: #000;
  } */
  a {
    display: flex;
    color: inherit;
  }
  /* .router-link-active{
    color: #000;
  } */
}
@keyframes headerIn {
  0% {
    transform: translateY(-140rem) !important;
  }
  100% {
    transform: translateY(0rem) !important;
  }
}
@keyframes headerOut {
  0% {
    transform: translateY(0rem);
  }
  100% {
    transform: translateY(-140rem);
  }
}
.header{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* .header .r{
  flex:1;
} */
 .h-nav{
  display: flex;
  align-items: center;
  font-size: 16rem;
  line-height: 80rem;
  color: #f5f5f7;
 }
 .h-nav .center{
  min-width: 148rem;
  font-style: normal;
  line-height: 80rem;
 }
 .h-nav .center:last-child{
  min-width: 106rem;
 }
 .h-nav .center{
  a{
    transition: color .3s;
    &:hover{
      color: #fff;
    }
  }
 }

/* ===== 行业方案 二级/三级导航 下拉 ===== */
 .h-nav .center{
  .industry-dropdown{
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: auto;
    max-width: 1760px;
    width: 92%;
    margin: 0 auto;
    z-index: 20;
    box-sizing: border-box;
    padding: 64rem 0rem 80rem;
    background: #000000;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity .4s ease, visibility .4s;

    /* 填补导航文字与下拉面板之间的空隙，防止悬停中断 */
    &::before{
      content: "";
      position: absolute;
      top: -35rem;
      left: 0;
      width: 100%;
      height: 70rem;
    }

    .industry-inner{
      width: 100%;
    }

    /* 二级导航（顶部一行行业名称 + 分割线） */
    .industry-titles{
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .title-cell{
        flex: 1 1 243rem;
        max-width:16.666%;;
        padding-bottom: 8rem;
        border-bottom: 1rem solid #4c4c4c;
        margin-right:40rem;
        opacity: 0;
        transform: translateY(10rem);
        transition: opacity .5s ease, transform .5s ease;
   
        a{
          display: block;
          font-size: 20rem;
          line-height: 28rem;
          color: #f5f5f7;
          transition: color .3s;

          &:hover{
            font-weight: bold;
          }
        }
      }
    }

    /* 三级导航（每个行业下的子菜单列） */
    .industry-cols{
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 7rem;

      .col{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width:16.666%;
      }

      .col-item{
        display: flex;
        align-items: flex-start;
        margin-top: 16rem;
        font-size: 14rem;
        line-height: 22rem;
        color: #ffffffbf;
        white-space: nowrap;
        opacity:0;
        transform: translateY(10rem);
        transition: opacity .5s ease, transform .5s ease, color .3s ease;

        &:first-child{
          margin-top: 0;
        }

        .tag{
          color: #707070;
          transition: color .3s;
        }

        &:hover,
        &:hover .tag{
          color: #ffffff;
        }
      }
    }
  }

  /* active 时下拉渐渐出现，二级/三级导航从左到右、从上到下依次淡入并上移 10rem */
  &.active{
    .industry-dropdown{
      opacity: 1;
      visibility: visible;
      pointer-events: auto;

      .title-cell,
      .col-item{
        opacity: 1;
        transform: translateY(0);
        transition: opacity .5s ease, transform .5s ease;
        transition-delay: var(--delay, 0ms);
      }
    }
  }
 }

/* ===== 技术路径 二级导航 下拉 ===== */
 .h-nav .center{
  .tech-dropdown{
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: auto;
    max-width: 1760px;
    width: 92%;
    margin: 0 auto;
    z-index: 20;
    box-sizing: border-box;
    padding: 64rem 0 80rem;
    background: #000000;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity .4s ease, visibility .4s;

    /* 填补导航文字与下拉面板之间的空隙，防止悬停中断 */
    &::before{
      content: "";
      position: absolute;
      top: -35rem;
      left: 0;
      width: 100%;
      height: 70rem;
    }

    .tech-inner{
      display: flex;
      gap: 40rem;
    }

    .tech-card{
      display: flex;
      flex-direction: column;
      width: 243rem;
      text-decoration: none;
      color: #f5f5f7;
      font-size: 20rem;
      line-height: 28rem;
      opacity: 0;
      transform: translateY(10rem);
      transition: opacity .5s ease, transform .5s ease;

      .tech-img-wrap{
        width: 243rem;
        height: 137rem;
        overflow: hidden;

        .tech-img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform .4s ease;
          display: block;
        }
      }

      &:hover .tech-img{
        transform: scale(1.08);
      }

      .tech-line{
        width: 100%;
        height: 1rem;
        background: #4c4c4c;
        margin: 16rem 0;
      }

      .tech-label{
        display: block;
        font-size: 20rem;
        line-height: 28rem;
        color: #f5f5f7;
      }
    }
  }

  &.active{
    .tech-dropdown{
      opacity: 1;
      visibility: visible;
      pointer-events: auto;

      .tech-card{
        opacity: 1;
        transform: translateY(0);
        transition: opacity .5s ease, transform .5s ease;
        transition-delay: var(--delay, 0ms);
      }
    }
  }
 }
header.fixed {
  position: fixed;
  top: 0;
}

.logo {
  display: flex;
  > img {
    width: 145rem;
  }
}
.center {
  display: flex;
  align-items: center;
}
.between {
  justify-content: space-between;
}
.line {
  height: 3px;
  flex-shrink: 0;
  background: var(
    --1,
    linear-gradient(
      92deg,
      #d33328 6.53%,
      #fee33c 28.81%,
      #f3f6d4 44.6%,
      #5de9f6 61.73%,
      #2535a0 87.99%
    )
  );
}
@media screen and (max-width: 1440px) {
  header,
  .header {
    height: 120rem;
  }
  /* 行业方案下拉：窄屏下适当收缩，避免溢出 */
  .h-nav .center .industry-dropdown {
    padding: 54rem 60rem 60rem;
    .industry-cols .col-item {
      font-size: 13rem;
    }
  }
}
@media screen and (max-width: 1199px) {
  .header_m {
    display: block;
    height: 110rem;
    background: #000;
    &.sty1{
      height: auto;
      background: transparent;
    }
  }
  .float {
    &.out {
      transform: translateY(-110rem);
    }
  }
  @keyframes headerIn {
    0% {
      transform: translateY(-110rem) !important;
    }
    100% {
      transform: translateY(0rem) !important;
    }
  }
  @keyframes headerOut {
    0% {
      transform: translateY(0rem);
    }
    100% {
      transform: translateY(-110rem);
    }
  }
  header {
    display: none;
  }
  .logo img {
    width: 97rem;
  }

  .hd-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 33rem 0;
  }
  .pop-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    z-index: 999;
    background-color: #000;
    > .wp {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }
  }
  .pop-bot {
    /* position: absolute;
    bottom: 0;
    left: 0;
    width: 100%; */
    .ll {
      display: flex;
      align-items: center;
      .lang {
        cursor: pointer;
        font-style: italic;
        text-transform: capitalize;
        color: #86868b;
        font-size: 14rem;
        margin-right: 8rem;
        &.act {
          color: #fff;
        }
      }
    }
    // .wp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #2b2b2b;
    padding-top: 30rem;
    padding-bottom: 30rem;
    // }
  }

  .hdnav {
    margin-top: -60rem;
    li {
      padding: 8rem 0;
      border-bottom: 1px solid #2A2A2A;
    }
    .nav-item-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .v1 {
      display: inline-block;
      vertical-align: middle;
      font-size: 20rem;
      text-decoration: none;
      color: #F5F5F7;
    }
    .nav-toggle {
      cursor: pointer;
    }
    .expand-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24rem;
      height: 24rem;
      font-size: 24rem;
      color: #F5F5F7;
      cursor: pointer;
      flex-shrink: 0;
    }
    .sub-nav {
      display: flex;
      flex-direction: column;
      padding: 8rem 0;
    }
    .sub-item {
      display: block;
      font-size: 13rem;
      line-height: 1.4em;
      color: #86868B;
      text-decoration: none;
      padding: 6rem 0;
    }
    .router-link-active {
      &.v1 {
        color: #fff;
      }
    }
  }
}
</style>
